// extracted by css-extract-rspack-plugin
export default {"wrapper":"_8f9a90c8"};